/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const recycledMixin = require("../recycled/recycledMixin.js");
const ChargerComment = {
	mixins: [recycledMixin],

	data() {
		return {
			thItems: ["序号","用户名","充电点","评论摘要", "评论时间", "删除人","删除时间","操作"],
			model:'spotMark',
			placeItem:"请选择搜索类型",

			searchList: [
				{value:"",text:"请选择搜索类型"},
				{value:"chargerName", text:"按充电点名称"},
				{value:"userName", text:"按用户名搜索"},
				{value:"deleter",text:"按删除人搜索"}
			],
			timeList: [
				{value:"",text:"请选择时间段"},
				{value:"deleteTime",text:"按删除时间搜索"},
				{value:"commentTime",text:"按评论时间搜索"}
			]
		}
	},
	route: {
		data: (transition) => {
			document.title = '充电点评论';
			transition.next()
		}
	}
}

module.exports = ChargerComment;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/recycled/charger-comment/charger-comment.js